export enum UserTypeEnum {
	HOLDER = 'TITULAR',
	DEPENDENT = 'DEPENDENTE',
}
